// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Add measurementId only if it's provided
if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  firebaseConfig.measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth immediately (synchronous)
export const auth = getAuth(app);

// Initialize Analytics only if measurementId is provided and analytics is supported
// Note: Analytics initialization is optional and won't break the app if it fails
// This is done asynchronously and doesn't affect auth
if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  isSupported()
    .then((supported) => {
      if (supported) {
        try {
          getAnalytics(app);
        } catch (error) {
          console.warn('Firebase Analytics initialization failed:', error);
        }
      }
    })
    .catch((error) => {
      // Silently fail - analytics is optional
      console.warn('Firebase Analytics not supported:', error);
    });
}
